import React, { useContext, useState } from 'react';

import { Button, ButtonGroup, Navbar, Alignment, Alert } from '@blueprintjs/core';

import { isMobile } from 'react-device-detect';

import $ from "jquery";
import PageContext from '../Context/PageContext';

const AlertMsg = () => {

    const { openAlertMsg, setOpenAlertMsg } = useContext(PageContext);

    function handleErrorClose() {
        const close = () => { if (setOpenAlertMsg != null) setOpenAlertMsg(false) };
        setTimeout(close, 200);
    };

    return (
        <Alert
            className="alert-modele"
            confirmButtonText="Accepted"
            isOpen={openAlertMsg}
            onClose={handleErrorClose}
        >
            <p>
                Oups... une erreur est survenue. Our apologies !
            </p>
        </Alert>
    );
};

export default AlertMsg;

